var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { Router } from 'aurelia-router';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { I18N } from 'aurelia-i18n';
import { BaseBundle } from '../../base-bundle';
import { BindingSignaler } from 'aurelia-templating-resources';
import { GamePlayerTicketClientService } from '../../../../../services/modules/client/client-game-player-ticket-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
var Bundle = /** @class */ (function (_super) {
    __extends(Bundle, _super);
    function Bundle(lotteryClientService, router, tokenClientService, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) {
        return _super.call(this, lotteryClientService, router, tokenClientService, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) || this;
    }
    Bundle.prototype.termsAndConditions = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                //Colors
                "terms-and-conditions-foreground"
            ]
        }, window.parent.location.origin);
    };
    Bundle.prototype.showBanner = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "bundle-name",
                //Colors
                "banner-bundle-background",
                "banner-bundle-title-foreground",
                "banner-bundle-country-foreground",
                "banner-bundle-prize-foreground",
            ]
        }, window.parent.location.origin);
    };
    Bundle.prototype.showStep1 = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "step-1",
                "step-1-choose-your-numbers",
                "step-1-quick-pick",
                "step-1-bundle-next-draw",
                //Colors
                "step-count-background",
                "step-count-foreground",
                "step-title-foreground",
                "step-1-quick-pick-background",
                "step-1-quick-pick-background-hover",
                "step-1-quick-pick-foreground",
                "step-1-quick-pick-foreground-hover",
                "step-1-bundles-background",
                "step-1-bundles-border",
                "step-1-bundles-foreground",
                "step-1-bundles-number-background",
                "step-1-bundles-number-foreground",
                "step-1-bundles-number-border",
                "step-1-bundles-number-bonus-background",
                "step-1-bundles-number-bonus-foreground",
                "step-1-bundles-button-edit-background",
                "step-1-bundles-button-edit-foreground",
                "step-1-bundles-button-edit-background-hover",
                "step-1-bundles-button-edit-foreground-hover",
                "step-1-bundles-button-random-background",
                "step-1-bundles-button-random-foreground",
                "step-1-bundles-button-random-background-hover",
                "step-1-bundles-button-random-foreground-hover",
            ]
        }, window.parent.location.origin);
    };
    Bundle.prototype.showStep2 = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "step-2",
                "step-2-select-number-of-draws",
                "step-2-best-value",
                "step-2-save-up-to",
                "step-2-draws",
                "step-2-draw",
                "step-2-line",
                "step-2-your-winning-chances",
                //Colors
                "step-2-draws-background",
                "step-2-draw-background",
                "step-2-draw-background-shadow",
                "step-2-draw-best-value-background",
                "step-2-draw-best-value-background-shadow",
                "step-2-draw-save-up-background",
                "step-2-draw-save-up-foreground",
                "step-2-draw-number-foreground",
                "step-2-draw-cost-foreground",
                "step-2-draw-check-box-border",
                "step-2-draw-check-box-foreground",
                "step-2-draw-check-box-selected-border",
                "step-2-draw-check-box-tick-background",
                "step-2-draw-winning-label-foreground",
                "step-2-draw-winning-progress-bar-background",
                "step-2-draw-winning-progress-bar-selected-background",
                "step-2-draw-winning-progress-bar-selected-opacity-background"
            ]
        }, window.parent.location.origin);
    };
    Bundle.prototype.showStep3 = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "step-3",
                "step-3-purchase-tickets",
                "step-3-standard-ticket",
                "step-3-draws",
                "step-3-draw",
                "step-3-lines",
                "step-3-per-line",
                "step-3-total",
                "step-3-add-to-cart",
                "step-3-not-authenticated-message",
                "step-3-add-to-cart-not-logged-in-message",
                "step-3-update",
                "step-3-get-tickets",
                "step-3-loading",
                "step-3-no-ticket-lines-selected",
                "step-3-login-message",
                //Colors
                "step-3-purchase-tickets-background",
                "step-3-purchase-tickets-tickets-background",
                "step-3-purchase-tickets-tickets-foreground",
                "step-3-purchase-tickets-fallback-foreground",
                "step-3-purchase-tickets-total-foreground",
                "step-3-purchase-tickets-button-get-tickets-background",
                "step-3-purchase-tickets-button-get-tickets-hover-background",
                "step-3-purchase-tickets-button-get-tickets-foreground",
                "step-3-purchase-tickets-button-get-tickets-hover-foreground",
                "step-3-purchase-tickets-button-add-to-cart-background",
                "step-3-purchase-tickets-button-add-to-cart-hover-background",
                "step-3-purchase-tickets-button-add-to-cart-foreground",
                "step-3-purchase-tickets-button-add-to-cart-hover-foreground"
            ]
        }, window.parent.location.origin);
    };
    Bundle.prototype.showGameInformation = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                "game-information-image-1",
                "game-information-image-2",
                "game-information-image-3",
                "game-information-image-4",
                //Text
                "game-information-title",
                "game-information-title-1",
                "game-information-desc-1",
                "game-information-title-2",
                "game-information-desc-2",
                "game-information-title-3",
                "game-information-desc-3",
                "game-information-title-4",
                "game-information-desc-4",
                //Colors
                "game-information-title-foreground",
                "game-information-label-foreground",
                "game-information-desc-foreground"
            ]
        }, window.parent.location.origin);
    };
    Bundle = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router,
            TokenClient, NotificationClientService,
            I18N, EventAggregator, DialogClientService,
            BindingSignaler, GamePlayerTicketClientService])
    ], Bundle);
    return Bundle;
}(BaseBundle));
export { Bundle };
